export enum VCallStatus {
  NOT_STARTED,
  IN_PROGESS,
  ENDED,
}
